import { Feature } from '../config';
import { useFeaturesQuery, useFeaturesSuspenseQuery } from '../query';
import { isFeatureEnabled } from '../utils/isFeatureEnabled';

export const useFeatureEnabled = <T extends string>(
  feature: Feature,
  audienceIds?: T[],
): boolean => {
  const { data: featureAudiences } = useFeaturesQuery();
  return isFeatureEnabled(feature, featureAudiences ?? {}, audienceIds);
};

export const useFeatureEnabledSuspense = <T extends string>(
  feature: Feature,
  audienceIds?: T[],
): boolean => {
  const { data: featureAudiences } = useFeaturesSuspenseQuery();
  return isFeatureEnabled(feature, featureAudiences ?? {}, audienceIds);
};
